import { ILogin, IPermissionProps } from "../../models/Login";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { IModal } from "./CallingHistory";
import { Accordion, AccordionTab } from "primereact/accordion";

import { baseUrl, Fetch, ILazyParams } from "../../shared/Fetch";
import { EmptySalEffFilter, Filter, IIVRFilter } from "./Filter";
import { format } from "date-fns";
import { Dialog } from "primereact/dialog";
import { safeFormatDate } from "../../models/DateFormatMapper";

export interface IVRUserList {
    id?: number,
    calldate?: string;
    callerID?: string;
    ext_Destination?: string;
    billsec?: number;
    disposition?: string;
    callstatus?: string;
    extension_ID?: string;
    extname?: string;
    displayName?: string;
    callRecordFilename?: string;
    extDestination?: string;
    callDate?: string;
}
export interface IFilter {
    fromDate?: Date | null,
    toDate?: Date | null,
    extension_ID?: string | undefined;

}

export const EmptyFilter: IFilter = {
    fromDate: new Date,
    toDate: new Date,
    extension_ID: "All"
}

interface Iprops {
    setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps,
    setReload: (is: boolean) => void,
}

export const EmptyExtCalling = {
    displayName: "",
}

export const Table = (props: Iprops) => {
    const [totalRecords, setTotalRecords] = useState(0);
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IVRUserList>, loading: boolean });
    const dt = useRef<any>(null);
    const [iVrffFilter, setIVrffFilter] = useState<IIVRFilter>(EmptySalEffFilter);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'id',
        sortOrder: -1
    });

    const [showAudioModal, setShowAudioModal] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">IVR Calling Details</h5>
        </div>
    );

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });


    // const loadTableData = async (extensionID: string, fromDate?: Date, toDate?: Date) => {
    //     if (_roles.includes(1) && iVrffFilter.extension_ID == "") {
    //         extensionID = "All"
    //     } else if (iVrffFilter.extension_ID == "") {
    //         extensionID = loginObj.ext_Destination
    //     }
    //     setTableData({ tableData: tableData.tableData, loading: true });
    //     const formattedFromDate = fromDate ? format(fromDate, "yyyy-MM-dd") : format(new Date(), "yyyy-MM-dd");
    //     const formattedToDate = toDate ? format(toDate, "yyyy-MM-dd") : format(new Date(), "yyyy-MM-dd");
    //     const response = await fetch(`https://billing.vitelglobal.com/vitelglobal_callrecords.php?username=Tekinspirations&password=UpBl9aEdDXo5OTHL&line=All&startdate=${formattedFromDate}&enddate=${formattedToDate}`);
    //     const text = await response.text();
    //     const parser = new DOMParser();
    //     const xmlDoc = parser.parseFromString(text, "application/xml");
    //     const records = xmlDoc.getElementsByTagName("record");
    //     const parsedData: IVRUserList[] = [];

    //     for (let i = 0; i < records.length; i++) {
    //         const record = records[i];
    //         parsedData.push({
    //             calldate: record.getElementsByTagName("calldate")[0]?.textContent || "",
    //             callerID: record.getElementsByTagName("src")[0]?.textContent || "",
    //             ext_Destination: record.getElementsByTagName("dst")[0]?.textContent || "",
    //             billsec: parseInt(record.getElementsByTagName("billsec")[0]?.textContent || "0"),
    //             disposition: record.getElementsByTagName("disposition")[0]?.textContent || "",
    //             callstatus: record.getElementsByTagName("callstatus")[0]?.textContent || "",
    //             extension_ID: record.getElementsByTagName("extension")[0]?.textContent || "",
    //             extname: record.getElementsByTagName("extname")[0]?.textContent || "",
    //         });
    //     }
    //     setTableData({ tableData: parsedData, loading: false });
    // };

    const loadTableData = async () => {
        // if (!_roles.includes(1)) {
        //     if (loginObj.ext_Destination != null) {
        //         iVrffFilter.extension_ID = loginObj.ext_Destination
        //     }
        // }
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Calling_Extension/callHistoryRecord", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${JSON.stringify(iVrffFilter)}`, props.toast);
        if (response) {
            const data: Array<any> = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const loadTableData1 = async (extension_ID: "All" | string) => {
        if (!_roles.includes(1)) {
            extension_ID = loginObj.ext_Destination
        }
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Calling_Extension/GetTodayCallRecordsbycompany", "GET", null, `extension_ID=${extension_ID}`, props.toast);
        if (response) {
            const data: Array<any> = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const callDate = (rowData: any) => {
        let date;
        if (rowData.callDate) date = format(new Date(rowData.callDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const callTime = (rowData: any) => {
        let date;
        if (rowData?.callDate) date = format(new Date(rowData?.callDate), 'hh:mm a').toUpperCase();
        else date = "";
        return (<>{date}</>);

    };

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const getTableDataCount = async () => {
        const response = await Fetch("Calling_Extension/callHistoryCount", "GET", null, `filter=${JSON.stringify(iVrffFilter)}`, props.toast);
        if (response) {
            const count: number = parseInt(await response.text(), 10);
            setTotalRecords(count);
        }
    }

    const getTableDataTodaysCount = async (extension_ID: "All" | string) => {
        const response = await Fetch("Calling_Extension/GetTodayCallRecordscount", "GET", null, `extension_ID=${extension_ID}`, props.toast);
        if (response) {
            const count: number = parseInt(await response.text(), 10);
            setTotalRecords(count);
        }
    };

    
    const buttonForLiveDownloadCallRecording = (data: IVRUserList | any) => {
        const handleClick = async () => {
            try {
                const response = await fetch(`${baseUrl}Calling_Extension/DownloadWav?fileUrl=${encodeURIComponent(data.callRecordFilename)}`);
                //const blob = await response.blob();
                if (!response.ok) {
                    console.error("Failed to fetch .wav file");
                    return;
                }
                const wavBlob = await response.blob();
                LiveCallRecording(wavBlob); // pass blob to conversion function
            } catch (error) {
                console.error("Error fetching WAV file:", error);
            }
        };

        return (
            <Button
                icon="pi pi-play text-primary"
                className="p-button-rounded p-button-success p-button-text mr-1"
                onClick={handleClick}
            />
        );
    };


    const onDownloadCallRecording = async (data: IVRUserList) => {
        const FileFolderStructure = (data?.callDate || "").split("T")[0].split("-");
        console.log(data);
        setShowAudioModal({
            singleData: {
                fileName: data.callRecordFilename,
                first: FileFolderStructure[0],
                second: FileFolderStructure[1],
                third: FileFolderStructure[2],
                id: data.id,
            }, open: true
        });
        //const response = await fetch(`${baseUrl}Calling_Extension/streamAudio?fileName=${data.callRecordFilename}&first=${FileFolderStructure[0]}&second=${FileFolderStructure[1]}&third=${FileFolderStructure[2]}`);
        // if (response) {
        // }
    };



    // const LiveCallRecording = async (url: string | any) => {
    //     try {
    //         setShowAudioModal({
    //             singleData: {
    //                 fileName: `https://your-backend.com/convert-wav-to-mp3?fileUrl=${encodeURIComponent(url)}`,
    //             },
    //             open: true,
    //         });
    //     } catch (error) {
    //         console.error("Error fetching audio file:", error);
    //     }
    // };
    const LiveCallRecording = async (wavBlob: Blob) => {
        const formData = new FormData();
        formData.append("file", wavBlob);

        try {
            const response = await fetch(`${baseUrl}Calling_Extension/ConvertWavToMp3Upload`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") || '{}').token}`,
                },
                body: formData,
            });

            if (!response.ok) {
                throw new Error("Failed to convert WAV to MP3");
            }

            const blob = await response.blob();

            if (blob.type !== "audio/mpeg") {
                console.error("Invalid MP3 blob type:", blob.type);
                return;
            }

            const mp3Url = URL.createObjectURL(blob);
            console.log("Generated MP3 URL:", mp3Url);

            setShowAudioModal({
                singleData: {
                    fileName: mp3Url,
                },
                open: true,
            });

        } catch (error) {
            console.error("Error converting WAV to MP3:", error);
        }
    };




    useEffect(() => {
        if (iVrffFilter.today_Record == true) {
            loadTableData1(iVrffFilter.extension_ID || "All");
            getTableDataTodaysCount(iVrffFilter.extension_ID || "All");
        } else {
            loadTableData();
            getTableDataCount();
        }
        // loadTableData();
        // getTableDataCount();
    }, [iVrffFilter, lazyParams, props.reload]);

    const DateFormat = loginObj.date_Format;
    return (
        <>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter IvrEffFilter={iVrffFilter} setIvrEffFilter={setIVrffFilter} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                emptyMessage="No Users found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                value={tableData.tableData} loading={tableData.loading}
                header={header}>
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                {/* <Column field="callDate" header="Call Date" body={callDate} /> */}
                <Column field="callDate" header="Call Date" body={(rowData: any) => safeFormatDate(rowData.callDate, "dd/MM/yyyy", DateFormat)} />
                <Column field="callDate" header="Call Time" body={callTime} />
                <Column field="callerID" header="Caller ID" />
                <Column field="extDestination" header="Destination" />
                <Column field="billSec" header="Bill Sec" />
                <Column field="disposition" header="Disposition" />
                <Column field="callStatus" header="Call Status" />
                <Column field="extensionID" header="Extension" />
                <Column field="extName" header="Ext Name" />
                {/* <Column header="Play Recording" body={buttonForDownloadCallRecording} /> */}
                {iVrffFilter.today_Record == true && <Column header="Play Recording1" body={buttonForLiveDownloadCallRecording} />}

            </DataTable>
            {/* <Dialog visible={showAudioModal.open} style={{ width: '50vw' }} header="Play Recording" modal className="p-fluid" onHide={() => setShowAudioModal({ singleData: {}, open: false })}>

                {showAudioModal.open && showAudioModal.singleData.fileName && <div> */}
            {/* <p>{`${baseUrl}Calling_Extension/streamAudio?fileName=${showAudioModal.singleData.fileName}&first=${showAudioModal.singleData?.first}&second=${showAudioModal.singleData?.second}&third=${showAudioModal.singleData?.third}`}</p> */}
            {/* <audio controls preload="auto">
                        <source src={`https://portal.jobvritta.com/api/Calling_Extension/streamAudio?fileName=${encodeURIComponent(showAudioModal.singleData.fileName)}&first=${showAudioModal.singleData?.first}&second=${showAudioModal.singleData?.second}&third=${showAudioModal.singleData?.third}`} type="audio/mpeg" />
                        Your browser does not support the audio element.
                    </audio>
                </div>}
            </Dialog> */}


            {showAudioModal.open && (
                <Dialog
                    header="Call Recording"
                    visible={showAudioModal.open}
                    style={{ width: '40vw' }}
                    onHide={() => setShowAudioModal({ open: false, singleData: null })}
                >
                    <audio controls autoPlay style={{ width: '100%' }}>
                        <source src={showAudioModal.singleData.fileName} type="audio/mpeg" />
                        Your browser does not support the audio element.
                    </audio>
                </Dialog>
            )}

        </>
    );
}